<h2 mat-dialog-title>
	{{ "WebviewerAnnotationHelpTitle" | translate }}
</h2>

<mat-dialog-content class="content">
	@if (isLoading()) {
	<mat-progress-spinner class="loading-spinner" mode="indeterminate" diameter="48"></mat-progress-spinner>
	}
	 @else if (loadError() || !content()) {
	<p>{{ "WebviewerAnnotationHelpLoadError" | translate }}</p>
	} @else {
	<mat-stepper orientation="horizontal">
		@for (step of content()?.steps; track $index) {
		<mat-step [label]="getLangValue(step.title)">
			<mat-card appearance="outlined">
				<mat-card-content>
					@if (step.imageSrc) {
					<img class="step-image" [src]="getLangValue(step.imageSrc)" />
					} @else if (step.videoSrc) {
					<video class="step-video" [src]="getLangValue(step.videoSrc)" controls></video>
					}
					<div class="step-body" [innerHTML]="getLangValue(step.body)"></div>
				</mat-card-content>
			</mat-card>
		</mat-step>
		}
	</mat-stepper>
	}
</mat-dialog-content>

<mat-dialog-actions class="actions">
	<mat-checkbox [(ngModel)]="doNotShowAgainModel" data-cy="do-not-show-again-checkbox">
		{{ "WebviewerAnnotationHelpDoNotShowAgain" | translate }}
	</mat-checkbox>
	<button mat-raised-button color="primary" [mat-dialog-close]="doNotShowAgainModel()" data-cy="close-button">
		{{ "Close" | translate }}
	</button>
</mat-dialog-actions>
